import React, { useState } from 'react';
import {
  Row,
  notification,
  Popconfirm,
  Popover,
  Button as Buttonantd,
  Col,
} from 'antd';
import { ButtonProps } from 'antd/lib/button';
import { UserSwitchOutlined } from '@ant-design/icons';
import { AssignProcTask } from '../services/workflow';
import FormInput from './FormInput';
import UsersList from './UsersList';
import PopoverController from './PopoverController';
import TaskAssignToMeButton from './TaskAssignToMeButton';
import { useDisplayFrameworkContext } from 'DisplayFramework/hooks/useDisplayFrameworkContext';
import Button from './Button';

export type MultiTaskAssignToUserButtonProps = ButtonProps & {
  proctaskidList: Array<{ proctaskid: number }>;
  label: string;
  refetch: () => void;
};

const MultiTaskAssignToUserButton: React.FC<
  MultiTaskAssignToUserButtonProps
> = ({ size = 'small', refetch, proctaskidList, label, ...props }) => {
  const [userid, setUserid] = useState<any>();
  const { getComponentLabel } = useDisplayFrameworkContext();

  return (
    <PopoverController>
      {({ setVisible, visible }) => (
        <Popover
          placement="bottomRight"
          visible={visible}
          trigger="click"
          onVisibleChange={setVisible}
          content={
            <>
              <Row>
                <FormInput name="selectUser" col style={{ width: '200px' }}>
                  <UsersList onChange={setUserid} />
                </FormInput>
              </Row>

              <Row justify="center" gutter={16}>
                <Col span={10}>
                  <Popconfirm
                    title="Are you sure?"
                    onConfirm={() => {
                      if (userid !== null) {
                        AssignProcTask({
                          proctaskidList: proctaskidList,
                          userid,
                        }).then((resp) => {
                          if (resp.code === '200') {
                            notification.success({ message: resp.message });
                            refetch();
                          } else {
                            notification.error({ message: resp.message });
                          }
                        });
                      }
                    }}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Buttonantd icon={<UserSwitchOutlined />} {...props}>
                      {label}
                    </Buttonantd>
                  </Popconfirm>
                </Col>
                <Col span={12}>
                  <TaskAssignToMeButton
                    proctaskidList={proctaskidList}
                    refetch={refetch}
                    label={getComponentLabel('getIt')}
                  ></TaskAssignToMeButton>
                </Col>
              </Row>
            </>
          }
        >
          <Button
            type="primary"
            style={{ height: '25px !important' }}
            comcode="assign"
            onClick={() => setVisible(true)}
          />
        </Popover>
      )}
    </PopoverController>
  );
};

export default MultiTaskAssignToUserButton;
